import { Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import {
  ActionKind,
  ActionParamsButton,
  BaseClickable,
  SpacingRow,
  SpacingRowAlign,
  SpacingUnit,
} from 'components/ui';
import { ToggleStateStore } from 'stores/common';

import s from './Title.module.scss';

type TitleProps = {
  showOnlySelectedStore: ToggleStateStore;
};

const Title: React.FC<TitleProps> = ({ showOnlySelectedStore }: TitleProps) => {
  const { t } = useTranslation();

  const toggleAction: ActionParamsButton<any> = React.useMemo(
    () => ({
      actionKind: ActionKind.button,
      complexOnClick: {
        onClick: showOnlySelectedStore.toggle,
      },
    }),
    [showOnlySelectedStore]
  );

  return (
    <SpacingRow align={SpacingRowAlign.center} hSpacing={SpacingUnit.unit3}>
      <Typography.Text className={s.title__heading}>
        {t('editForm.chooseFields')}
      </Typography.Text>
      <BaseClickable action={toggleAction} withHover>
        <Typography.Text className={s.title__text}>
          {showOnlySelectedStore.opened
            ? t('editForm.showAllFields')
            : t('editForm.showChosenFieldsOnly')}
        </Typography.Text>
      </BaseClickable>
    </SpacingRow>
  );
};

export default observer(Title);
